import React from "react";
import {API_URL, defaultSessionDurationMinutes, minutesPerPaper} from "../constants";
import {isBreakSession, isPaperSession, secondsToTimeString, timeStringToSeconds} from "../commons";
import {connect} from "react-redux";
import {addCalendarSession, addSession, removeFromUnassigned, updateCalendarSession} from "../redux/actions";

class TimeSlot extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            style: {}
        };

        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
        this.handleDrop = this.handleDrop.bind(this)
    }

    handleDragOver(event) {
        /*
        * The ondragover event specifies where the dragged data can be dropped.
        * By default, data/elements cannot be dropped in other elements. To allow a drop, we must prevent the default
        * handling of the element. This is done by calling the event.preventDefault() method.
        * */
        event.preventDefault();

        this.setState((state, props) => {
            return {style: {backgroundColor: "#6256A6"}}
        })
    }

    handleDragLeave(event) {
        event.preventDefault();

        this.setState({style: {}})
    }

    async postSession(data) {
        const response = await fetch(API_URL + '/sessions', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + this.props.user.api_token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw Error(response.statusText);
        const json = await response.json();

        /* Store */
        this.props.addSession(json);

        return json;
    }

    async _sessionDropped(session) {
        /* Compute session duration. For paper sessions, duration is based on the number of papers the session has */
        let sessionDurationInMinutes = isPaperSession(session) ? session.papers.length * minutesPerPaper : defaultSessionDurationMinutes;

        /* If dropped session is of type Break, then we need to create the session first to obtain an ID */
        if (isBreakSession(session)) {
            try {
                session = await this.postSession(session);
            } catch (e) {
                alert(e);
                return;
            }
        }

        /* Build data to be sent*/
        const body = {
            session_id: session.id,
            room_id: this.props.roomId,
            date: this.props.dateStr,
            start_time: secondsToTimeString(this.props.timeInSeconds),
            end_time: secondsToTimeString(this.props.timeInSeconds + sessionDurationInMinutes * 60)
        };

        fetch(API_URL + '/calendar', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + this.props.user.api_token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(body),
        }).then((response) => {
            if (!response.ok) throw Error(response.statusText);    // Will go to .catch
            return response.json();
        }).then((result) => {
            this.props.removeFromUnassigned(result.data.session.id);
            this.props.addCalendarSession(result.data);
            // Clear background color
            this.setState({style: {}})

        }).catch((error) => {
            alert(error);
        });
    }

    async _calendarSessionDropped(calendarSession) {
        const {roomId, timeInSeconds} = this.props; // time corresponding to current time slot

        const sessionDurationInSeconds = timeStringToSeconds(calendarSession.end_time) - timeStringToSeconds(calendarSession.start_time);

        const body = {
            room_id: roomId,
            date: calendarSession.date,
            start_time: secondsToTimeString(timeInSeconds),
            end_time: secondsToTimeString(timeInSeconds + sessionDurationInSeconds)
        };

        fetch(API_URL + '/calendar/' + calendarSession.id, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + this.props.user.api_token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(body),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);    // Will go to .catch
                return response.json();
            })
            .then((result) => {
                /* Update calendar session */
                this.props.updateCalendarSession(calendarSession.id, result.data);
                // Clear background color
                this.setState({style: {}})
            })
            .catch((error) => {
                alert(error.toString());
            })
    }

    async handleDrop(event) {
        event.preventDefault();     // Needed to work
        let data = JSON.parse(event.dataTransfer.getData("text/plain"));

        switch (data.source) {
            case 'calendarSession':
                this._calendarSessionDropped(data.session);
                break;
            default:
                this._sessionDropped(data.session);
        }
    }

    render() {
        const {roomId, calendarSessions} = this.props;
        return (
            <td className={"timeslot dragpastehere r" + roomId}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragLeave}
                onDrop={this.handleDrop}
                style={this.state.style}>
                {calendarSessions}
            </td>
        )
    }
}

export default connect(
    null,
    {addCalendarSession, addSession, removeFromUnassigned, updateCalendarSession}
)(TimeSlot);
